const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const getToken = () => localStorage.getItem("rm_access_token") || "";
export const setToken = (t) => localStorage.setItem("rm_access_token", t);

// Ask the backend whether a token maps to an approved request. Fail closed.
export async function verifyToken(token) {
  if (!token) return false;
  try {
    const r = await fetch(`${API}/access/verify?token=${encodeURIComponent(token)}`);
    return r.ok;
  } catch {
    return false;
  }
}

export const resumeUrl = () => `${API}/auth/resume`;
